import { render, staticRenderFns } from "./RelevantPlayer.vue?vue&type=template&id=b23eb478&scoped=true&"
import script from "./RelevantPlayer.vue?vue&type=script&lang=js&"
export * from "./RelevantPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RelevantPlayer.vue?vue&type=style&index=0&id=b23eb478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23eb478",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VApp,VCard,VCardText,VCardTitle,VContainer,VFlex,VImg,VLayout,VProgressLinear})
